import { FETCH_HOMEPAGE_REQUEST, FETCH_HOMEPAGE_SUCCESS, FETCH_HOMEPAGE_ERROR } from "./homePageConstTypes"




const initialFilterState = {
    loading: false,
    pageData: { },
    error: ''
}

export const homePageDataReducer = (state = initialFilterState, action) => {
    switch (action.type) {
        case FETCH_HOMEPAGE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_HOMEPAGE_SUCCESS:
            return {
                ...state,
                pageData: action.payload,
                error: ''
            }
        case FETCH_HOMEPAGE_ERROR:
            return {
                ...state,
                pageData: {},
                error: action.payload
            }
        default:
           return state;
    }
}

